<template>
  <div class="textPerguntasFrequentes" :style="style.container">
    <Container gray>
      <ul>
        <li>
          <h1>1. Quando e onde será realizado o III Circuito Corrida e Caminhada Cidade de Deus?</h1>
          <p>Sábado, dia 20/10/2018, na Cidade de Deus, com abertura dos portões a partir das 6h. Confira a programação completa <router-link :style="style.link" :to="{ name: 'home', hash: '#programacaoAncora' }">aqui</router-link>.</p>
        </li>
        <li v-for="(pergunta, index) in perguntas" :key="index">
          <h1 v-html="pergunta.titulo"></h1>
          <p v-html="pergunta.resposta"></p>
        </li>
      </ul>
    </Container>
  </div>
</template>

<script>
import Container from '@/components/Container'
import colors from '@/services/colors'

export default {
  components: {
    Container
  },
  data() {
    return {
      perguntas: [
        {
          titulo: '2. Quem pode se inscrever no evento?',
          resposta: 'Somente podem realizar a inscrição funcionários da Organização Bradesco que atuam no estado de São Paulo. Esses funcionários também podem inscrever seus dependentes de até 11 anos e 12 meses na caminhada kids.',
        },
        {
          titulo: '3. Familiares podem participar?',
          resposta: 'Familiares podem e devem participar do evento, será um dia especial. Aqueles que não são funcionários, conforme descrito acima, não podem se inscrever para participar da corrida de 5km, do revezamento duplo misto de 5km e da caminhada de 2,5km, porém podem acompanhar as crianças na caminhada kids.',
        },
        {
          titulo: '4. Quais são as modalidades esportivas do evento?',
          resposta: 'São quatro modalidades: corrida (5km), caminhada (2,5km), revezamento em dupla mista (5km) e caminhada kids (1km).<br/>IMPORTANTE: na caminhada kids, a criança deverá estar acompanhada durante todo o tempo por um responsável.',
        },
        {
          titulo: '5. O kit é composto por quais materiais e onde deve ser retirado?',
          resposta: 'O kit dos adultos é composto por camiseta, sacochila e nº de peito com alfinetes para prendê-lo. Além disso, para aqueles que participarem da corrida ou revezamento, será entregue um chip para cronometragem do tempo no dia do evento. <br/>O kit das crianças tem uma camiseta tamanho 12, a sacochila. Você pode retirar o seu kit nos dias 18 e 19 de outubro, das 8h às 18h, no Quiosque da Praça de Esportes (próximo ao lago). E também, no sábado, dia 20 de outubro, a partir das 6h, na arena principal na tenda “Retirada de kit”.',
        },
        // {
        //   titulo: '6. Qual é a prazo para se inscrever?',
        //   resposta: 'As inscrições serão encerradas 02 (dois) dias antes da data designada para a realização da corrida (20 de outubro de 2018, sábado), ou em data anterior a esta, caso seja atingido o limite de participantes definido para cada modalidade.',
        // },
        {
          titulo: '6. Além da Corrida, do Revezamento Duplo e da Caminhada haverá outras atividades?',
          resposta: 'Sim! Teremos foodtrucks, atrações para toda a família e muita animação.',
        },
        {
          titulo: '7. Serão distribuídos prêmios? ',
          resposta: 'Sim. Os 03 (três) primeiros atletas colocados na categoria masculina e feminina na corrida de 5 km e do revezamento receberão troféu e poderão, eventualmente, receber outros prêmios.',
        },
        // {
        //   titulo: '9. Como devo me preparar para a Corrida, para o Revezamento Duplo Misto e para Caminhada?',
        //   resposta: 'Confira aqui www.corridabradesco.com.br algumas dicas importantes. ',
        // },
        {
          titulo: '8. Não consegui retirar meu kit nos dias indicados. Como devo proceder?',
          resposta: 'Você poderá retirar o kit no sábado, dia 20 de outubro, a partir das 6h, na arena principal na tenda “Retirada de kit”. Chegue com antecedência e evite filas e atrasos.',
        },
        {
          titulo: '9. Alguém pode fazer a retirada do kit no meu lugar?',
          resposta: 'O Kit poderá ser retirado por qualquer pessoa, mediante apresentação do crachá funcional e ou documento de identificação, como por exemplo o RG. O kit para o revezamento pode ser retirado por um dos representantes da dupla.',
        },
        {
          titulo: '10. Como vai funcionar o Revezamento Duplo Misto?',
          resposta: 'Monte uma dupla de corredores, pode ser de ambos os sexos. Cada atleta correrá 2,5km e o primeiro corredor passará o bastão para sua dupla quando terminar o seu trecho.',
        },
      ]
    }
  },
  computed: {
    style() {
      return {
        container: {
          color: colors.blue
        },
        link: {
          color: colors.red
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  line-height: 25px;
}
a {
  text-decoration: underline
}
h1 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 3px;
}
li {
  margin-bottom: 30px;
  &:last-child {
    margin-bottom: 0
  }
}
</style>
